<app-dialog-banner [dialogRef]="dialogRef" [text]="title">
</app-dialog-banner>
<mat-dialog-content class="mat-typography" style="max-width: 800px; min-height: 600px"
    [attr.data-form-ready]="ready ? 'true' : null">
    <app-field-set [fieldSet]="fieldSet" [isPhone]="isPhone" [initComplete]="ready"></app-field-set>
    <div [ngStyle]="data.transfer ? {'color':'blue' } : {'color': 'red'}"
        style="display: flex; align-items: center; gap: 10px; margin-left: 20px; margin-right: 20px; border:1px solid; padding:10px; border-radius:5px; background-color: #f5f5f5; margin-top: -10px;">

        <mat-icon style="font-size: 48px; height: 48px; width: 48px;">
            {{icon}}
        </mat-icon>

        <div style="flex: 1;">
            <p style="margin: 0; font-size: small; text-align: left; line-height: 1.2em; word-break: break-word;">
                {{comment}}
            </p>
        </div>

    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    @if (!fieldSet.formGroup?.valid) {
        <button mat-raised-button i18n (click)="highlightErrors()">Show Errors</button>
    }
    <button mat-raised-button mat-dialog-close>Cancel</button>
    @if(data.transfer) {
        <button mat-raised-button (click)="changeOwner()" [disabled]="!fieldSet.formGroup?.valid" color="primary"
            data-save-button cdkFocusInitial i18n>Transfer Ownership</button>
    } @else {
        <button mat-raised-button (click)="addContact()" [disabled]="!fieldSet.formGroup?.valid" color="primary"
            data-save-button cdkFocusInitial i18n>Add Contact(s)</button>
    }

</mat-dialog-actions>
